/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
var searchPartMixin = require('../modules/mixins/searchpart.mixin');
var trackingUtils = require('../modules/utils/tracking.utils.js');
var cons;
var validator;

Odigeo.defineWidget('passengers_search_manager', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        defaults: {
            numAdults: 1,
            numChildren: 0,
            numInfants: 0,
            kid0Age: '',
            kid1Age: '',
            kid2Age: '',
            kid3Age: '',
            kid4Age: '',
            kid5Age: '',
            infant0Age: '',
            infant1Age: '',
            infant2Age: '',
            infant3Age: '',
        },

        init: function() {
            this.options = Odigeo.parseOptions(this.widget.options);
            return searchPartMixin.getMixin().init.apply(this, arguments);
        },

        getNumAdults: function() {
            return parseInt(this.get('numAdults') || this.defaults.numAdults, 10);
        },

        getNumChildren: function() {
            return parseInt(this.get('numChildren') || this.defaults.numChildren, 10);
        },

        getNumInfants: function() {
            return parseInt(this.get('numInfants') || this.defaults.numInfants, 10);
        },

        getPassengers: function() {
            return {
                adults: parseInt(this.get('numAdults') || this.defaults.numAdults, 10),
                children: parseInt(this.get('numChildren') || this.defaults.numChildren, 10),
                infants: parseInt(this.get('numInfants') || this.defaults.numInfants, 10),
            };
        },

        setPaxByType: function(paxType, val) {
            if (Odigeo._.includes(Odigeo._.values(cons.PAX_TYPES), paxType)) {
                var paxTypeAttributeName = 'num' + Odigeo.Utils.capitalize(paxType);
                this.save(paxTypeAttributeName.toString(), val);
            } else {
                this.trigger('error:paxType', paxType);
            }
        },

        parse: function(searchParams) {
            var defaultParams = {
                numAdults: searchParams.numAdults,
                numChildren: searchParams.numChildren,
                numInfants: searchParams.numInfants,
            };
            var ageParams = Odigeo.AB.isOfferChildrenAgeDesktop ? this.getAgeParamsFromSearch(searchParams) : {};
            return Odigeo._.extend(defaultParams, ageParams);
        },

        getAgeParamsFromSearch: function(searchParams) {
            var infantAges = this.getAgeParams(searchParams, searchParams.numInfants, 'infant');
            var kidAges = this.getAgeParams(searchParams, searchParams.numChildren, 'kid');
            return Odigeo._.extend(kidAges, infantAges);
        },
        getAgeParams: function(searchParams, numPeople, elementType) {
            return Odigeo._.reduce(Odigeo._.range(numPeople), function(result, i) {
                result[elementType + i + 'Age'] = searchParams[elementType + i + 'Age'];
                return result;
            }, {});
        },
        getLimits: function() {
            var limits = this.widget.options.limits;
            var passengers = this.getPassengers();
            var adults = passengers.adults;
            var children = passengers.children;
            var infants = passengers.infants;
            var maxAdults = limits.total - children - infants;
            var maxChildren = Math.min(limits.total - adults - infants,
                adults * limits.childrenPerAdult - infants);
            var maxInfants = Math.min(limits.total - adults - children,
                adults * limits.childrenPerAdult - children,
                adults * limits.infantsPerAdult);
            var minAdults = Math.max(Math.round((children + infants) / limits.childrenPerAdult),
                infants, 1);

            return {
                adults: {
                    min: minAdults,
                    max: maxAdults,
                },
                children: {
                    max: maxChildren,
                },
                infants: {
                    max: maxInfants,
                },
            };
        },
    })),

    viewClass: Odigeo.View.extend({
        templateSettings: {
            evaluate: /\{\{#([\s\S]+?)\}\}/g,
            interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
            escape: /\{\{\{([\s\S]+?)\}\}\}/g,
        },

        events: {
            'tap .passengers_search_input': 'onTapInInput',
            'tap .passengers_search_append': 'onTapInInput',
            'tap .passengers_search_close_btn': 'onTapInCloseBtn',
            'tap .adult_quick_access': 'onTapQuickPax',
        },

        selectors: {
            viewTemplate: Odigeo.AB.isCssVariationHeaderDesktop ? '.passengers_search_template_cobalt' : '.passengers_search_template',
            inputTemplate: Odigeo.AB.isCssVariationHeaderDesktop ? '.passengers_search_input_template_cobalt' : '.passengers_search_input_template',
            limitsTemplate: '.passengers_search_limits_template',
            limitsCobaltTemplate: '.passengers_search_limits_cobalt_template',
            input: '.passengers_search_input',
            passengersWrapper: '.view_container',
        },

        slctrs: {
            spinners: {
                adults: '.adults_item',
                children: '.children_item',
                infants: '.infants_item',
            },
            switchers: {
                kids0Age: '.kids0Age',
                kids1Age: '.kids1Age',
                kids2Age: '.kids2Age',
                kids3Age: '.kids3Age',
                kids4Age: '.kids4Age',
                kids5Age: '.kids5Age',
                infants0Age: '.infants0Age',
                infants1Age: '.infants1Age',
                infants2Age: '.infants2Age',
                infants3Age: '.infants3Age',
            },
            container: '.passengers_search_container',
            dropbdownSelector: '.passengers_search_dropdown',
            msgContainer: '.passengers_search_error_container',
        },

        init: function() {
            this.widget.options = Odigeo.parseOptions(this.widget.options);
            this.listenTo(this.model, 'change', this.render);
            this.listenTo(Odigeo.Events.fake, 'fake:blur', this.onBlur);
            this.model.listenSearchModelProperty('focused', Odigeo._.bind(this.onChangeFocusSearch, this));
            this.model.listenSearchModelProperty('type', Odigeo._.bind(this.updateValues, this));
        },

        onChangeFocusSearch: function(model, changed) {
            if (changed !== this.selectors.input) {
                this.toggle(cons.HIDE);
            }
        },

        initializeSpinners: function() {
            Odigeo._.each(this.slctrs.spinners, function(spinner, key) {
                var $spinner = this.$(spinner);
                this.addSelectorToCache(key, $spinner);
                Odigeo.UIElements.enhanceSpinner($spinner);
                $spinner.on('change', Odigeo._.bind(this.onChangeSpinner, this, key));
            }, this);
            return this;
        },

        initializeSwitchers: function() {
            Odigeo._.each(this.slctrs.switchers, function(switcher, key) {
                var $switcher = this.$(switcher);
                this.addSelectorToCache(key, $switcher);
                Odigeo.UIElements.enhanceSwitcher($switcher);
                $switcher.on('change', Odigeo._.bind(this.onChangeSwitcher, this, key));
            }, this);
            return this;
        },

        configSpinners: function(limits) {
            Odigeo._.each(this.slctrs.spinners, function(selector, key) {
                var minRange = limits[key].min;
                var maxRange = limits[key].max;
                var $spinner = this.$(selector);

                $spinner.trigger('config', {
                    maxRange: maxRange,
                    max: maxRange,
                });
                if (!Odigeo._.isUndefined(minRange)) {
                    $spinner.trigger('config', {
                        minRange: minRange,
                        min: minRange,
                    });
                }
            }, this);
        },

        updateLimits: function() {
            this.configSpinners(this.model.getLimits());
            this.checkMsg(cons.MSG.LIMITS);
            return this;
        },

        renderTemplate: function($tmpl, $wrapperTmpl, data) {
            var tmpl = Odigeo._.template($tmpl.html(), this.templateSettings);
            var dataTmpl = Odigeo._.extend({}, data || this.model.toJSON());

            $wrapperTmpl.html(tmpl(dataTmpl));
            return this;
        },

        isOpen: function() {
            return this.$(this.slctrs.container).hasClass('open');
        },

        render: function() {
            var childAges = {};
            var infantAges = {};
            if (Odigeo.AB.isOfferChildrenAgeDesktop) {
                childAges = this.getAges(this.model.attributes, 'numChildren', 'kid');
                infantAges = this.getAges(this.model.attributes, 'numInfants', 'infant');
            }
            this.renderTemplate(
                this.$cachedSelectors.viewTemplate,
                this.$cachedSelectors.passengersWrapper,
                {'passengers': this.getRenderData(), 'childAges': childAges, 'infantAges': infantAges}
            );
            this.initializeSpinners();
            if (Odigeo.AB.isOfferChildrenAgeDesktop) {
                this.initializeSwitchers();
            }

            this.updateLimits();
        },

        toggle: function(hasToOpen) {
            var $container = this.$(this.slctrs.container);

            hasToOpen = Odigeo._.isUndefined(hasToOpen) ? !$container.hasClass('open') : hasToOpen;
            $container.toggleClass('open focus', hasToOpen);

            if (Odigeo.AB.isCssVariationHeaderDesktop) {
                this.$(this.slctrs.dropbdownSelector).toggleClass('open focus', hasToOpen);
            }
            return this;
        },

        checkMsg: function(type) {
            if (!Odigeo._.includes(cons.MSG, type)) {
                return false;
            }

            var $msgContainer = this.$(this.slctrs.msgContainer);
            var key = Odigeo._.find(Odigeo._.keys(validator[type]), function(fnKey) {
                return validator[type][fnKey].call(this.model);
            }, this);
            var hasMsg = !Odigeo._.isUndefined(key);

            const templateSelector = Odigeo.AB.isCssVariationHeaderDesktop ? 'limitsCobaltTemplate' : 'limitsTemplate';
            var tmpl = Odigeo._.template(this.$cachedSelectors[templateSelector].html(), this.templateSettings);

            $msgContainer.toggle(hasMsg);
            $msgContainer.html(tmpl({msg: this.widget.options.translate.limits[key]}));
            return hasMsg;
        },

        onTapInCloseBtn: function(event) {
            if (Odigeo.AB.isCssVariationHeaderDesktop) {
                event.stopImmediatePropagation();
            }
            var hasToClosePassengersModification = Odigeo.AB.isOfferChildrenAgeDesktop
                ? this.allAgesFilled('.kid_age_container', this.model.getNumChildren())
                    & this.allAgesFilled('.infant_age_container', this.model.getNumInfants())
                : true;

            this.$el.find('.passengerssearch_validation_message').toggleClass('odf-hidden', hasToClosePassengersModification);
            if (hasToClosePassengersModification) {
                this.toggle(cons.HIDE);
            }
            return this;
        },

        allAgesFilled: function(containerClass, numPeople) {
            var visibleSelectors = this.$el.find(containerClass).not('.odf-hidden');
            var areSelectorsFilled = Odigeo._.eq(Odigeo._.reduce(visibleSelectors, function(accum, element) {
                var isEmptySelector = $(element).find('.age_selector_visible_value').text() === '';
                if (!isEmptySelector) {
                    accum.push($(element));
                }
                $(element).toggleClass('od-validation-error', isEmptySelector);
                return accum;
            }, []).length, numPeople);

            return areSelectorsFilled;
        },

        onChangeSpinner: function(spinner, ev) {
            this.model.setPaxByType(spinner, parseInt($(ev.target).val(), 10));
            this.$cachedSelectors.input.html(this.getText());
            return this;
        },

        onChangeSwitcher: function(switcher, ev) {
            var $selector = $(ev.currentTarget);
            var $selectorContainer = $selector.closest('.age_selector_container');
            var selectedOptionAge = $selector.find(':selected').text();
            var containerText = ': ' + selectedOptionAge;
            var attribute = this.getModelAttribute(switcher);

            this.model.set(attribute, selectedOptionAge);
            $selectorContainer.find('.age_selector_visible_value').text(containerText);
            this.modifyKidsAndChildrenAgeSelectorVisibility(this.model.getNumChildren(), this.model.getNumInfants());
        },
        getModelAttribute: function(selector) {
            return selector.replace('s', '');
        },
        modifyKidsAndChildrenAgeSelectorVisibility: function(numKids, numInfants) {
            this.showAgeContainers('.kid_age_container', numKids, 'kid');
            this.showAgeContainers('.infant_age_container', numInfants, 'infant');
        },
        onTapInInput: function() {
            this.toggle();
            this.model.setSearchModelProperty('focused', this.selectors.input);
            this.model.setSearchModelProperty('editsearch', true);
            trackingUtils.trackEvent('searcher_flights', 'open_change_search_pax');
            return this;
        },
        showAgeContainers: function(containerClass, maxPeople, peopleType) {
            Odigeo._.each(this.$el.find(containerClass), function(ageSelector) {
                $(ageSelector).toggleClass('odf-hidden', maxPeople < $(ageSelector).attr('data-'+peopleType+'-age'));
            });
        },
        onTapQuickPax: function(ev) {
            var numAdults = $(ev.target).data('quick-adults');
            this.model.save('numAdults', parseInt(numAdults, 10));
            this.model.setSearchModelProperty('editsearch', true);
            trackingUtils.trackEvent('searcher_flights', 'passenger_shortcut_' + numAdults);
            return this;
        },

        onBlur: function(ev) {
            if ($(ev.target).closest(this.$el).length === 0) {
                this.toggle(cons.HIDE);
            }
            return this;
        },

        getRenderData: function() {
            var passengers = this.model.getPassengers();
            return Odigeo._.extend({}, {
                numAdults: passengers.adults,
                numChildren: passengers.children,
                numInfants: passengers.infants,
                inputText: this.getText(),
                limits: this.model.getLimits(),
                openedClass: this.isOpen() ? 'open focus' : '',
                quickPaxSelectedClass: {
                    one: passengers.adults === 1 ? 'active' : '',
                    two: passengers.adults === 2 ? 'active' : '',
                    three: passengers.adults === 3 ? 'active' : '',
                },
            }, this.model.attributes);
        },
        getAges: function(modelAttributes, typeOfKid, key) {
            return Odigeo._.reduce(Odigeo._.range(modelAttributes[typeOfKid]), function(result, i) {
                result[i] = modelAttributes[key + i + 'Age'] !== '' ? ': ' + modelAttributes[key + i + 'Age'] : '';
                return result;
            }, {});
        },

        getText: function() {
            var trans = this.widget.options.translate;
            var passengers = this.model.getPassengers();
            var tmpl = Odigeo._.template(this.$cachedSelectors.inputTemplate.html(), this.templateSettings);

            return tmpl({
                input: {
                    adults: {
                        num: passengers.adults,
                        text: Odigeo.Utils.pluralizeAll(trans.adults, passengers.adults),
                    }, children: {
                        num: passengers.children,
                        text: Odigeo.Utils.pluralizeAll(trans.children, passengers.children),
                    }, infants: {
                        num: passengers.infants,
                        text: Odigeo.Utils.pluralizeAll(trans.infants, passengers.infants),
                    }, total: {
                        num: passengers.adults + passengers.children + passengers.infants,
                    },
                },
            });
        },

        updateValues: function() {
            var data = Odigeo._.pick(this.model.getOriginalData(), ['numAdults', 'numChildren', 'numInfants']);
            var passengers = Odigeo._.mapKeys(this.model.getPassengers(), function(value, key) {
                return 'num' + Odigeo._.capitalize(key);
            });
            if (!Odigeo._.isEmpty(data) && !Odigeo._.isEqual(data, passengers)) {
                this.model.save('numAdults', parseInt(data.numAdults, 10));
                this.model.save('numChildren', parseInt(data.numChildren, 10));
                this.model.save('numInfants', parseInt(data.numInfants, 10));
                this.render();
            }
        },
    }),
}));

cons = {
    HIDE: false,
    SHOW: true,
    PAX_TYPES: {
        ADULTS: 'adults',
        CHILDREN: 'children',
        INFANTS: 'infants',
    },
    MSG: {
        LIMITS: 'limits',
    },
};

validator = {
    limits: {
        total: function() {
            var passengers = this.getPassengers();
            return passengers.adults + passengers.children + passengers.infants === this.widget.options.limits.total;
        },

        childrenPerAdult: function() {
            var passengers = this.getPassengers();
            return (passengers.children + passengers.infants) / passengers.adults === this.widget.options.limits.childrenPerAdult;
        },
    },
};
